// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__3_SJs","gif":"Header_gif__2tKiM","aaruushlogo":"Header_aaruushlogo__C0d8S"};